import * as THREE from "three";
import React, { useRef } from "react";
import { Torus, Sphere, useTexture } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import useStore from "../AppStore";
import path from "../path";

const PlanetThree = React.forwardRef((props, ref) => {
  const astroRef = useRef(null);

  useFrame(({ clock }) => {
    const top = useStore.getState().top;
    astroRef.current.rotation.y = -clock.elapsedTime * 0.1 - top * 0.01;
  });

  const normalMap = useTexture(path + "/assets/planets/Planeta2Normal.png");
  const roughMap = useTexture(path + "/assets/planets/Planeta2Roughness.png");
  const emissMap = useTexture(path + "/assets/planets/Emission.png");

  return (
    <group ref={ref} {...props} dispose={null}>
      <Sphere args={[1, 32, 32]} ref={astroRef}>
        <meshStandardMaterial
          color={"#222"}
          normalMap={normalMap}
          roughnessMap={roughMap}
          emissiveMap={emissMap}
          emissive={"white"}
          emissiveIntensity={props.emission || 4}
        />
      </Sphere>
    </group>
  );
});

useTexture.preload(path + "/assets/planets/Planeta2Normal.png");
useTexture.preload(path + "/assets/planets/Planeta2Roughness.png");
useTexture.preload(path + "/assets/planets/Emission.png");

export default PlanetThree;
